import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { filterBoolean } from '@recruitee/common';
import { OfferBrief, OfferItem } from '@recruitee/http/types';

import { OffersBriefSelectors } from '../store/offers-brief.selectors';
import { OfferItemsSelectors } from '../store/offers.selectors';

@Injectable({ providedIn: 'root' })
export class OfferSelectService {
  constructor(private store: Store) {}

  public getOffers(): Observable<OfferItem[]> {
    return this.store.select(OfferItemsSelectors.active).pipe(filterBoolean);
  }

  public getArchivedOffers(): Observable<OfferBrief[]> {
    return this.store.select(OffersBriefSelectors.archived).pipe(filterBoolean);
  }
}
